const listeners = new Map();

const normalizeEvents = (events) => Array.isArray(events) ? events : [events];

export const eventBus = {
	$on(events, callback) {
		normalizeEvents(events).forEach((event) => {
			if (!listeners.has(event)) {
				listeners.set(event, new Set());
			}

			listeners.get(event).add(callback);
		});
	},

	$once(events, callback) {
		normalizeEvents(events).forEach((event) => {
			const onceCallback = (...args) => {
				this.$off(event, onceCallback);
				callback(...args);
			};

			this.$on(event, onceCallback);
		});
	},

	$off(events, callback) {
		normalizeEvents(events).forEach((event) => {
			if (!listeners.has(event)) {
				return;
			}

			if (!callback) {
				listeners.delete(event);
				return;
			}

			listeners.get(event).delete(callback);

			if (listeners.get(event).size === 0) {
				listeners.delete(event);
			}
		});
	},

	$emit(event, ...args) {
		if (!listeners.has(event)) {
			return;
		}

		listeners.get(event).forEach((callback) => callback(...args));
	}
};

export const EventBusPlugin = {
	install(app) {
		app.config.globalProperties.$eventBus = eventBus;
	}
};

export default eventBus;
